import { render, staticRenderFns } from "./ConfirmationPublish.vue?vue&type=template&id=75801804&"
import script from "./ConfirmationPublish.vue?vue&type=script&lang=js&"
export * from "./ConfirmationPublish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports